require('prismjs/themes/prism-coy.css')
require('katex/dist/katex.min.css')

import React from 'react'

import Layout from './src/layout/Layout/Layout'
import RootLayout from './src/layout/RootLayout/RootLayout'

const pjson = require('./package.json')
export const appVersion = pjson.version

export const wrapRootElement = ({ element }) => (
    <RootLayout>{element}</RootLayout>
)

export const wrapPageElement = ({ element, props }) => {
    return <Layout {...props}>{element}</Layout>
}

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
    const { location: prevLocation } = prevRouterProps || {}
    const { location } = routerProps

    if (location.pathname === '/search') {
        if (prevLocation && prevLocation.pathname === location.pathname) {
            return false
        }
    }

    return true
}
